<pv-view #view
         *ngIf="state$ | async as state"
         toolbarTitle="Simplified Reports">

    <!-- TOOLBAR ACTIONS -->
    <div pv-view-tools class="report-actions">
        <button mat-icon-button
                matTooltip="Refresh Reports"
                (click)="reload()">
            <mat-icon>refresh</mat-icon>
        </button>

        <button mat-icon-button
                matTooltip="Add Report"
                (click)="add()">
            <mat-icon>add</mat-icon>
        </button>
    </div>

    <!-- ADD -->
    <button pv-view-fab mat-fab color="primary"
            matTooltip="Add Report"
            (click)="add()">
        <mat-icon>add</mat-icon>
    </button>

    <!-- PAGINATION & SORT FOOTER -->
    <div pv-view-footer class="pv-table-footer">

        <label class="mat-caption mr-12" for="advanced_report_index_sort">Sort</label>
        <mat-select [formControl]="columnControl"
                    id="advanced_report_index_sort"
                    class="report-index-sort-select">
            <mat-option *ngFor="let opt of state.sortOptions" [value]="opt.id">
                {{ opt.label }}
            </mat-option>
        </mat-select>
        <button type="button" class="ml-12" mat-icon-button (click)="toggleSortOrder($event)">
            <mat-icon
                [svgIcon]="orderControl.value === 'asc' ? 'fa:solid-sort-alpha-up' : 'fa:solid-sort-alpha-down'">
            </mat-icon>
        </button>

        <mat-paginator [length]="state.total"
                       [pageSize]="state.page.size"
                       [pageIndex]="state.page.index"
                       (page)="paginate($event)"
                       [pageSizeOptions]="state.pageSizeOptions">
        </mat-paginator>
    </div>

    <!-- SIDEBAR -->
    <div pv-view-sidebar>
        <mat-tab-group>

            <!-- FILTER TAB -->
            <mat-tab label="Alpha">
                <p style="padding: 0px 10px;">
                    This is an experimental feature which is still in development. Your participation is greatly appreciated. And we would love to hear your feedback.
                </p>
            </mat-tab>

        </mat-tab-group>
    </div>

    <!-- BODY STATUS: OK -->
    <div pv-view-body class="report-index-body" [ngSwitch]="state.status">

        <!-- STATUS MESSAGE: LOADING -->
        <pv-view-loader *ngSwitchCase="'LOADING'" message="Loading Samples..."></pv-view-loader>

        <!-- BODY STATUS: EMPTY -->
        <pv-view-message *ngSwitchCase="'EMPTY'"
                         heading="No results"
                         message="The current filters does not match any Reports. Update the filters or add a Report."
                         icon="error">
            <button mat-raised-button color="accent"
                    pvMessageAction
                    (click)="resetFilter()">
                Reset Filters
            </button>
            <button mat-raised-button
                    color="primary"
                    pvMessageAction
                    (click)="add()">
                Add
            </button>
        </pv-view-message>

        <!-- STATUS MESSAGE: INVALID -->
        <pv-view-message *ngSwitchCase="'INVALID'"
                         heading="Invalid Filter Parameters"
                         message="Unable to load data with given filter and sort parameters."
                         icon="error">
            <button mat-raised-button color="accent"
                    pvMessageAction (click)="resetFilter()">
                Reset Filters
            </button>
            <button mat-raised-button color="primary" pvMessageAction
                    (click)="reload()">
                Reload
            </button>
        </pv-view-message>


        <!-- STATUS MESSAGE: ERROR / DEFAULT -->
        <pv-view-message *ngSwitchDefault [heading]="state.status | descStatusTitle"
                         [message]="state.status | descStatusMessage:'Sample'" icon="error">
            <button mat-raised-button color="primary" pvMessageAction
                    (click)="reload()">Reload</button>
        </pv-view-message>


        <!-- STATUS MESSAGE: OK (ngSwitch placeholder) -->
        <ng-container *ngSwitchCase="'OK'"></ng-container>

        <!-- REPORT TABLE -->
        <div *ngIf="state.status === 'OK' || state.status === 'LOADING'"
            class="pv-advanced-report-table pv-responsive-table">

            <table cdk-table
                   [dataSource]="state.data"
                   [trackBy]="trackReport"
                   matSort
                   [matSortDisableClear]="true"
                   [matSortDirection]="state.sort.order"
                   [matSortActive]="state.sort.column"
                   (matSortChange)="sort($event)">

                <!-- TITLE -->
                <ng-container cdkColumnDef="label">
                    <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="label">Title</th>
                    <td cdk-cell *cdkCellDef="let row">
                        <a class="title-line" [routerLink]="[row.key]">
                            {{ row.label }}
                        </a>
                        <div class="caption-line">{{ row.description }}</div>
                    </td>
                </ng-container>

                <!-- ACTIONS -->
                <ng-container cdkColumnDef="actions">
                    <th cdk-header-cell *cdkHeaderCellDef>Actions</th>
                    <td cdk-cell *cdkCellDef="let row">

                        <!-- PREVIEW -->
                        <a mat-icon-button [routerLink]="[row.key]"
                           matTooltip="View Report">
                            <mat-icon [matBadge]="row.access == 'ANYONE' ? 'S' : null">pageview</mat-icon>
                        </a>
                        <button mat-icon-button [matMenuTriggerFor]="reportMenu"
                                [matMenuTriggerData]="{report: row}"
                                matTooltip="More Actions">
                            <mat-icon>more_horiz</mat-icon>
                        </button>

                    </td>
                </ng-container>

                <!-- TIMESTAMPS -->
                <ng-container cdkColumnDef="timestamps">
                    <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="updatedAt">
                        <mat-icon>access_time</mat-icon>
                    </th>
                    <td cdk-cell *cdkCellDef="let row">
                        <span class="caption-line">Created
                            {{ row.createdAt | date:'mediumDate' }}</span>
                        <span class="caption-line">Updated
                            {{ row.updatedAt | date:'mediumDate' }}</span>
                    </td>
                </ng-container>


                <!-- Row Defs -->
                <tr cdk-header-row
                    *cdkHeaderRowDef="state.displayColumns">
                </tr>
                <tr cdk-row
                    *cdkRowDef="let row; columns: state.displayColumns;">
                    <!-- [class.selected]="selection.isSelected(row.key)" -->
                </tr>

            </table>
        </div>

        <!-- Report Context Menu -->
        <mat-menu #reportMenu="matMenu">
            <ng-template matMenuContent let-report="report">
                <a mat-menu-item [routerLink]="[report.key]">
                    <mat-icon>pageview</mat-icon>
                    <span>View Report</span>
                </a>
                <button mat-menu-item (click)="edit(report)">
                    <mat-icon>edit</mat-icon>
                    <span>Edit Report</span>
                </button>
                <button mat-menu-item (click)="shareReport(report.key, report.ownerOrgKey)">
                    <mat-icon>share</mat-icon>
                    <span>Share Report</span>
                </button>
                <button mat-menu-item (click)="deleteReport(report)">
                    <mat-icon>delete</mat-icon>
                    <span>Delete Report</span>
                </button>
            </ng-template>
        </mat-menu>
    </div>
</pv-view>